import MarkerClusterer from '@googlemaps/markerclustererplus'
import { useState, useEffect, useContext, useMemo } from 'react'
import TripsContext from '../contexts/TripsContext'

type LatLng = {
    lat: number
    lng: number
}

export type IMarker = {
    id: any
    latLng: LatLng
    icon?: any
    onClick?(event, marker, id): void
    onMouseOver?(event, marker, id): void
    onMouseOut?(event, marker, id): void
}

type IProps = {
    markers: IMarker[]
    clusterImagePath?: string
}

export const useMarkers = (props: IProps): any => {
    const { mapInstance } = useContext(TripsContext)
    const [cluster, setCluster] = useState<any>()
    const [markers, setMarkers] = useState<any[]>([])

    const deleteMarkers = (markers: any[] = []) => {
        if (markers.length === 0) return
        markers.forEach(ele => {
            ele?.setMap(null)
        })

        setMarkers(undefined)
    }

    const buildMarkers = (mapInstance, markers = []) => {
        if (!mapInstance) return

        const markersFiltered = markers.filter(ele => {
            const { lat, lng } = ele
            const ruleA = lat && lng
            // const ruleB = mapInstance.getBounds()?.contains(new google.maps.LatLng(lat, lng))
            const ruleB = true

            return ruleA && ruleB
        })

        const result = markersFiltered.map(ele => {
            return buildMarker(mapInstance, ele)
        })

        return result
    }

    const buildMarker = (mapInstance, { lat, lng, icon, onClick, onMouseOver, onMouseOut, id }) => {
        const options = { position: new google.maps.LatLng(+lat, +lng), icon, map: mapInstance }
        const marker = new google.maps.Marker(options)

        marker.addListener('click', event => {
            if (onClick) onClick(event, marker, id)
        })

        marker.addListener('mouseover', event => {
            if (onMouseOver) onMouseOver(event, marker, id)
        })

        marker.addListener('mouseout', event => {
            if (onMouseOut) onMouseOut(event, marker, id)
        })

        return marker
    }

    const buildCluster = (markers: any[], clusterImagePath) => {
        if (!clusterImagePath) return

        if (!cluster) {
            setCluster(
                new MarkerClusterer(mapInstance, markers, {
                    imagePath: clusterImagePath
                })
            )
        } else {
            cluster.clearMarkers()
            cluster.addMarkers(markers)
        }
    }

    useEffect(() => {
        deleteMarkers(markers)
        setMarkers(buildMarkers(mapInstance, props?.markers))

        if (mapInstance) {
            google.maps.event.addListener(mapInstance, 'center_changed', () => {
                // setMarkers(buildMarkers(mapInstance, props?.markers))
            })
        }
    }, [mapInstance, props])

    // const markers = useMemo(() => {
    //     deleteMarkers(markers)

    //     return buildMarkers(mapInstance, props?.markers)
    // }, [mapInstance, props])

    useEffect(() => {
        buildCluster(markers, props?.clusterImagePath)
    }, [markers])

    return { markers }
}
